'use client';

/**
 * ESignatureFinalCTA — V3 closing block for /e-signature.
 *
 * Builds copy + accent for the shared FinalCTA section. The violet
 * accent (#A78BFA) matches the page's hero halo.
 */

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';
import { demoHref } from '../demo/demoInterest';

type Props = { lang: Locale };

const REGISTER = `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`;

const ESignatureFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const ctaPrimary = { label: t('ESignature/FinalCTA/cta_demo'), href: demoHref(lang, 'e-signature') };
  const ctaSecondary = { label: t('ESignature/FinalCTA/cta_signup'), href: REGISTER };

  return (
    <FinalCTA
      accent="#A78BFA"
      copy={{
        headlineA: t('ESignature/FinalCTA/headline_a'),
        headlineB: t('ESignature/FinalCTA/headline_b'),
        subhead: t('ESignature/FinalCTA/subhead'),
        ctaPrimary,
        ctaSecondary,
      }}
    />
  );
};

export default ESignatureFinalCTA;
